import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from '../404';
import EditPage from './edit';
import ViewPage from './view';
import ListPage from './list';
import AddPage from './add';

const CandidatePages = () => (
  <Switch>
    <Route exact path={'/candidates/add'} component={AddPage} />
    <Route exact path={'/candidates/:hash'} component={ViewPage} />
    <Route exact path={'/candidates/:hash/edit'} component={EditPage} />
    <Route exact path={'/candidates'} component={ListPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

export default CandidatePages;
